import ele from 'mint-ui'


export default {
    contentPic:function(content){
		return content.replace(/height=/g,"")
                     .replace(/width:\s?\d{1,5}px;?/g,"")
                     .replace(/\/Public\//g,picurl);

	},
	doback:function(){
        if(location.hash=="#/user/order/3"||location.hash=="#/user/report"||location.hash=="#/user/mybook"){
            router.push("/user/index");
        }else{
            router.go(-1)  
        }   
    },
    link:function(a){
        router.push(a);
    },
    top:function(){
       window.scrollTo(0,0);
    },
    toy:function(y){
     setTimeout(function(){
        window.scrollTo(0,y);
     },300)
    },
    log:function(d){
        console.log(d);
    },
    saveposition:function(){
        mydata.position= document.documentElement.scrollTop||document.body.scrollTop;
        //console.log("保存位置",mydata.position);
    },
    two:function(num){
    	return num<10?"0"+num:num;
    },
    rand:function(min,max){
        return Math.ceil(Math.random()*(max-min))+min;
       },
    get_tk:function(){
      return "tk"+new Date().getTime()+fun.rand(100000,999999);
    },   
    rand_str(len) {
        　　var len = len || 32;
        　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';  
        　　var maxPos = $chars.length;
        　　var pwd = '';
        　　for (var i = 0; i < len; i++) {
        　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        　　}
        　　return pwd;
        },
    post:function(url,data,fn,loading){
        if(typeof data=="function"){
            fn=data;
            data={};
        }
    	var data=data?data:{};
        data.token=this.local("token");
        if(!data.token){
            if(this.local("gtoken")){
                data.gtoken=this.local("gtoken");
            }else{
                data.gtoken=this.rand_str(10)+new Date().getTime();
                this.local("gtoken",data.gtoken);
            }
        }
    	data.hos=data.hos?data.hos:this.local("hos");
        if(!loading){
           ele.Indicator.open(); 
        }
        var _this=this;
    	axios.post(url,data).then(function(d){
    		var d=d.data;
            ele.Indicator.close();
    		if(d.status==0&&d.info=="请先登录"){
               _this.logout();
              _this.alert(d.info,()=>{
                  router.push("/login");
              })
    		}else{
              fn(d);
    		}
    	}).catch(function(e){
    		console.log(e);
    	})
    },
    alert(msg,fn){
        ele.MessageBox.alert(msg).then(()=>{
            fn&&fn();
        })
    },
    check_sf:function(sf){
    	var sf1=/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;//15位
	    var sf2=/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}(\d|[a-zA-Z])$/;//18位
	    if(sf.match(sf1)||sf.match(sf2)){return true;}
	    return false;
    },
    key0:function(obj){
    	for(var i in obj){
    		return i;
    	}
    },
    copy:function(obj){
    	var re={};
    	for(var i in obj){
    		re[i]=obj[i];
    	}
    	return re;
    },
    url:function(){
	     var re=location.hash;
	     re=re.replace("#","").replace(/\//g,"_");
	     return re;
    },
    cache:function(k,v){
        if(v===null){
            sessionStorage.removeItem(k);return true;
        }
    	if(v){
    		sessionStorage[k]=JSON.stringify(v);
    		return true;
    	}else{
    		var re=sessionStorage[k];
    		if(!re){return false;}
    		return JSON.parse(re);
    	}
    },
    local:function(k,v,expire){
        if(v===null){
            localStorage.removeItem(k);return;
        }
        if(v){
            var data={
                value:v,
                expire:expire?expire:0,
            }
            localStorage.setItem(k,JSON.stringify(data));
            return;
        }else{
            var re=localStorage[k];
            if(!re){return false;}
            try {
                re=JSON.parse(re);
                if(re['expire']>0 && re['expire']<new Date().getTime()){
                    return false;
                }
                return re['value']; 
            } catch (error) {
                return re;
            }
            
        }
    },
    islogin:function(){
       if(!this.local("token")||!this.local('expire')){
        //    this.logout();
           console.log("logout");
           return false;
        }
       var now=new Date().getTime();
       if(this.local('expire')>now){
           return true;
        }
       return false;
    },
    logout:function(){
        this.local('token',null);
        this.local("expire",null);
        this.local("name",null);
        this.local('avatar',null);
        this.local("now_hos",null);
    },
    in_array:function(k,arr){
    	var len=arr.length;
    	for(var i=0;i<len;i++){
    		if(k==arr[i]){return true;}
    	}
    	return false;
    },
    is_weixin:function(){
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/micromessenger/i)){
            return true;
        }
         return false;
    },
    cookie:function(key,value,expire){
        if(!value){
                var arr,reg=new RegExp("(^| )"+key+"=([^;]*)(;|$)");
                if(arr=document.cookie.match(reg)){
                    return unescape(arr[2]);  
                }else{return false;}
        }else{
                var exdate=new Date();
                exdate.setDate(exdate.getDate()+expire);
                document.cookie=key+ "=" +escape(value)+((expire==null) ? "" : ";expires="+exdate.toString())+";path=/";
        }
    }





}//end


// WEBPACK FOOTER //
// ./src/js/fun.js